import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {Router} from '@angular/router';
import {FabricCollectionService} from '../../../Services/fabric-collection.service';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {FabricCollection} from '../../../Models/FabricCollection';

@Component({
  selector: 'app-archive-fabric-collection-view',
  templateUrl: './archive-fabric-collection-view.component.html',
  styleUrls: ['./archive-fabric-collection-view.component.scss']
})
export class ArchiveFabricCollectionViewComponent implements OnInit {
  @ViewChild('fabricCollectionsRowDetail', {static: false}) fabricCollectionsRowDetail: any;
  @ViewChild('dealerPriceTemp', {static: true}) dealerPriceTemp;
  @ViewChild('customerPriceTemp', {static: true}) customerPriceTemp;
  public grid: Grid;
  public fabricCollectionId: number;
  public fabricCollectionName: string;
  @ViewChild('readdModel', {static: false}) readdModel = null;

  constructor(private router: Router, private fabricCollectionService: FabricCollectionService,
              private translateService: TranslateService, private broadCastService: BroadcastService) {
  }

  ngOnInit() {

    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.fabric-collection.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.fabric-collection.attached_fabrics',
          prop: 'attachedFabrics',
          sortable: true,
          type: TextColumn.type,
          minWidth: 155,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.fabric-collection.dealer_price',
          prop: 'dealerPrice',
          sortable: true,
          type: TextColumn.type,
          minWidth: 165,
          translate: true,
          valueTemplate: this.dealerPriceTemp,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.fabric-collection.customer_price',
          prop: 'customerPrice',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          minWidth: 265,
          valueTemplate: this.customerPriceTemp
        },
        <TextColumn>{
          name: 'doctrine.fabric-collection.status',
          prop: 'status',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case true:
                return this.translateService.instant('global.active');
              case false:
                return this.translateService.instant('global.inactive');
            }
          }
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'feather icon-plus',
              tooltip: 'global.readd',
              onclick: row => {
                this.fabricCollectionId = row.id;
                this.fabricCollectionName = row.name.bold();
                this.readdModel.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
          ]
        },
      ],
      service: this.fabricCollectionService,
      rememberURL: this.router.url,
      method: 'getFabricCollectionList',
      defaultSort: 'position',
      rowDetailTemplate: this.fabricCollectionsRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      archive: true ,
    };

  }

  public readd() {
     this.fabricCollectionService.readdFabricCollection(this.fabricCollectionId).subscribe((res) => {
       this.broadCastService.broadcast('refreshGrid', 'getFabricCollectionList');
       this.readdModel.hide();
     });
  }
  goToFabricCollectionOverview() {
    this.router.navigateByUrl('back-office/fabric-collection/overview');

  }
}
